// import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux'
// import { useNavigate } from "react-router-dom";
// import { userDetails } from "../modules/Auth/authSlice";
// import { Spinner } from "react-bootstrap";
// import { useAuth } from "../context/AuthContext";

// const ProtectedRoute = ({ children }) => {
//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { isAuthenticated } = useAuth();
//     console.log("isAuthenticated---", isAuthenticated)

//     useEffect(() => {
//         const checkAuthenticated = async () => {
//             dispatch(userDetails()).then(res => {
//                 if (res.payload === undefined) {
//                     navigate('/');
//                 } else {
//                     if (res.payload.data.success === false) {
//                         navigate('/');
//                     }
//                 }  
//             });
//         }

//         checkAuthenticated();
//     }, [dispatch,navigate]);

//     // return (isAuthenticated === true) ? children : <div className="loading show"> <Spinner className="loader" animation="grow" variant="primary" /> </div>;
//     return (isAuthenticated === true) ? children : <div className="d-flex justify-content-center align-items-center" style={{ zIndex: 9999999, height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, backgroundColor: "rgba(0,0,0,0.5)" }}>
//     <Spinner animation="border" role="status" variant="light">
//         <span className="visually-hidden">Loading...</span>
//     </Spinner>
//     </div>;
// };

// export default ProtectedRoute;


import React, { useEffect }  from 'react';
import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserDetails } from '../redux/slice/authSlice';

const PrivateRoute = ({ children }) => {
  // const isAuthenticated = token !== null ? true : false;

  const { isAuthenticated, isAuthChecked } = useSelector((state) => state.auth);  
  const dispatch = useDispatch();
  

 useEffect(() => {
    if (!isAuthChecked) {
      dispatch(fetchUserDetails());
    }
  }, [dispatch, isAuthChecked]);
  // console.log("isAuthenticated---", isAuthenticated)

  // If the authentication state is still loading, you can display a loader or spinner.
  if (!isAuthChecked) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ zIndex: 9999999, height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0, backgroundColor: "rgba(0,0,0,0.5)" }}>
        <Spinner animation="border" role="status" variant="light">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  // If the user is authenticated, render the children (protected route content)
  // If not, redirect to the login page
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
